import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { rootPath, userCreatorStagePath } from "@travily/routes";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { UserCreatorNameStepView } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  name: string | null;
}

type FormData = {
  name: string;
};

const UserCreatorNameStep = ({ stage_index, stage_order, name }: PageProps) => {
  const { bindField, currentStage, totalStages, onBack, onPrimary, primaryPending } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => userCreatorStagePath(stage),
      entryUrl: rootPath(),
    },
    stageName: "name",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { name: name ?? "" },
  });

  const nameField = bindField("name", { validateOn: "submit" });

  const topBarActions = useCreatorTopBarActions();

  return (
    <>
      <Head title={t("web.user.creator.name.show.meta_title")}>
        <meta name="description" content={t("web.user.creator.name.show.meta_description")} />
      </Head>
      <UserCreatorNameStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        value={nameField.value}
        error={nameField.errorMessage}
        onChange={nameField.onChange}
        onBlur={nameField.onBlur}
      />
    </>
  );
};

export default UserCreatorNameStep;
